import { makeStyles,fade } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    color: theme.palette.text.disabled,
    border: `1px solid rgba(21, 21, 21, 0.1)`,
    padding: 16,
    display: 'flex',
    borderRadius: 6,
    flex:1
  },
  subTaskTitle: {
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.secondary,
    marginBottom: 12,
  },
  alignCenter: {
    alignItems: 'center',
  },
  addTaskText: {
    fontSize: 14,
    letterSpacing: 0.5,
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
  addTaskView: {
    color: theme.palette.text.disabled,
    border: `1px solid rgb(222, 226, 230)`,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14)',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxWidth: 922
  },
  textFieldRoot: {
    width: '100%',
    '& .MuiInput-underline': {
      '&:before': {
        display: 'none',
      },
    },
  },
  addTaskFooter: {
    borderTop: `1px solid ${theme.palette.borderColor.main}`,
    padding: '4px 16px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
  },
  chipRoot: {
    border: '0 none',
    borderLeft: `1px solid ${theme.palette.borderColor.main}`,
    paddingLeft: 16,
    borderRadius: 0,
    marginRight: 20,
    height: 26,
  },
  TaskListSelectorView: {
    borderLeft: `1px solid ${theme.palette.borderColor.main}`,
    paddingLeft: 16,
    height: 26,
  },
  btnRoot: {
    color: theme.palette.text.disabled,
  },
  statusTotal: {
    boxShadow: 'rgba(115, 82, 199, 0.176) 0px 0.5rem 1.25rem',
    borderRadius:6,
    backgroundColor: fade(theme.palette.primary.main, 0.8),
    height: 58,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    padding: '0 1rem',
    color: '#fff',
    marginRight: '1rem',
    minWidth: 150
  },
  statusForfallna: {
    boxShadow: 'rgba(115, 82, 199, 0.176) 0px 0.5rem 1.25rem',
    borderRadius:6,
    backgroundColor: fade(theme.palette.secondary.main, 0.8),
    height: 58,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    padding: '0 1rem',
    color: '#fff',
    minWidth: 150
  }
}));
export default useStyles;
